module.exports = __webpack_public_path__ + "static/media/pin.1bcdf632.svg";